import DetailsProfileGlobal from "../Components/Global/DetailsProfileGlobal";
import ViewProfileListGlobal from "../Components/Global/ViewProfileListGlobal";
import AllTaxsAccountantPr from "../Page/Accountant/Others/AllTaxsAccountantPr";
import BuildingDetails from "../Page/Owner/Building/BuildingDetails";
import Dashboard from "../Page/Owner/OwnerPartnerDashboard/Dashboard";
import UnitDetails from "../Page/Owner/Units/UnitDetails";
// import Personaldetails from "../Page/Public/Personaldetails";
// import RmaDevDashboard from "../Page/RmaDeveloper/RmaDevDashboard";

export const RmaDeveloperRoutes = [
 
  {
    path: "/admin/buildinglist",
    Component: (
      <ViewProfileListGlobal key={343431434} allowedRoles={["Admin"]} />
    ),
    Title: "Viewbuilding",
  },
  {
    path: "/admin/managerlist",
    Component: (
      <ViewProfileListGlobal key={"managerlist343431434"} allowedRoles={["Admin"]} />
    ),
    Title: "Viewbuilding",
  },
  {
    path: "/admin/workerlist",
    Component: (
      <ViewProfileListGlobal key={"worker-list343431434"} allowedRoles={["Admin"]} />
    ),
    Title: "worker-listds",
  },
  {
    path: "/admin/accountantlist",
    Component: (
      <ViewProfileListGlobal key={"accountant-list343431434"} allowedRoles={["Admin"]} />
    ),
    Title: "worker-listds",
  },
  {
    path: "/admin/partnerlist",
    Component: (
      <ViewProfileListGlobal key={"partner-list343431434"} allowedRoles={["Admin"]} />
    ),
    Title: "worker-listds",
  },
  {
    path: "admin/partner-details/:id",
    Component: (
      <DetailsProfileGlobal key={"admin/partner-details"}  allowedRoles={["Admin"]} />
    ),
    Title: "DetailsProfileGlobal",
  },
  {
    path: "admin/manager-details/:id",
    Component: (
      <DetailsProfileGlobal key={"admin/manager-details"}  allowedRoles={["Admin"]} />
    ),
    Title: "DetailsProfileGlobal",
  },
  {
    path: "admin/accountant-details/:id",
    Component: (
      <DetailsProfileGlobal key={"admin/accountant-details"}  allowedRoles={["Admin"]} />
    ),
    Title: "DetailsProfileGlobal",
  },
  {
    path: "admin/worker-details/:id",
    Component: (
      <DetailsProfileGlobal key={"admin/worker-details"}  allowedRoles={["Admin"]} />
    ),
    Title: "DetailsProfileGlobal",
  },
  {
    path: "admin/tenant-details/:id",
    Component: (
      <DetailsProfileGlobal key={"admin/tenant-details"}  allowedRoles={["Admin"]} />
    ),
    Title: "DetailsProfileGlobal",
  },
  {
    path: "admin/owner-details/:id",
    Component: (
      <DetailsProfileGlobal key={"admin/owner-details"}  allowedRoles={["Admin"]} />
    ),
    Title: "DetailsProfileGlobal",
  },
  {
    path: "/admin/tenantlist",
    Component: (
      <ViewProfileListGlobal key={"tenant-list43431434"} allowedRoles={["Admin"]} />
    ),
    Title: "worker-listds",
  },
  {
    path: "/admin/building-details/:id",
    Component: (
      <BuildingDetails key={"admin/building-details-list43431434"} allowedRoles={["Admin"]} />
    ),
    Title: "worker-listds",
  },
  {
    path: "/admindashboard",
    Component: <Dashboard key={33} allowedRoles={["Admin"]} />,
    Title: "Buildinglist",
  },
  

  
  {
    path: "/admin/ownerlist",
    Component: <ViewProfileListGlobal key={"ownerlist431434"} allowedRoles={["Admin"]}  />,
    Title: "Ownerlist",
  },

  {
    path: "admin/unit-details/:id",
    Component: <UnitDetails key={"oadmin/unit-details/:idst431434"} allowedRoles={["Admin"]} />,
    Title: "UnitDetails",
  },

  {
    path: "admin/taxation-information",
    Component: (
      <AllTaxsAccountantPr
        key="omin/taxation-informatixation-information"
        allowedRoles={["Admin"]}
      />
    ),
    Title: "TaxDetailsAccountantPr",
  },


];
